import { Coordinates } from '../types/common/address';

export namespace CoordinatesUtil {
  // Basic distance between two points
  const getDistanceBetweenTwoCoordinates = (a: Coordinates, b: Coordinates) => {
    return Math.sqrt(Math.pow(a.longitude - b.longitude, 2) + Math.pow(a.latitude - b.latitude, 2));
  };

  export function getLargestDistanceFromCenter(coordinates: Coordinates[], center: Coordinates): number {
    let max = 0;
    coordinates.forEach(co => {
      const distance = getDistanceBetweenTwoCoordinates(center, co);
      if (distance > max) max = distance;
    });
    return max;
  }

  export function getCenter(coordinates: Coordinates[]): Coordinates {
    let longitude = 0;
    let latitude = 0;
    coordinates.forEach(co => {
      longitude += co.longitude;
      latitude += co.latitude;
    });
    longitude /= coordinates.length;
    latitude /= coordinates.length;
    return { latitude, longitude };
  }
}
